import { Button, Card, Modal, ModalBody, ModalHeader } from 'flowbite-react';
import { usePostHog } from 'posthog-js/react';
import { useCallback, useState } from 'react';
import { InlineWidget } from 'react-calendly';

export function SelectProduct() {
  const posthog = usePostHog();
  const logEventToPosthog = useCallback(
    (eventName: string) => {
      posthog.capture(eventName);
    },
    [posthog],
  );
  const [openModal, setOpenModal] = useState(false);
  return (
    <>
      <div className='flex min-h-screen w-full place-content-center items-center overflow-hidden pt-14'>
        <Card className='mt-6'>
          <div className='flex w-full flex-col items-center justify-center space-y-4 px-8'>
            <h1 className='text-center text-3xl font-bold text-gray-900'>Welcome to Maverick Optimizer Lite</h1>
            <p className='text-center text-lg text-gray-600'>
              Generate awesome subject lines and preview text for your emails
            </p>
            <p className='mb-6 text-center text-gray-500'>Choose an option below to begin</p>
          </div>

          <Button
            className='w-72 content-center place-self-center rounded-lg bg-linear-to-br from-purple-600 to-blue-500 px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-linear-to-bl focus:outline-none focus:ring-4 focus:ring-blue-300'
            onClick={() => {
              logEventToPosthog('optimizerLiteGenerateIndividualEmailClicked');
              window.location.replace('/optimizer-lite/dashboard/');
            }}
          >
            Generate for an individual email
          </Button>
          <Button
            className='w-72 place-self-center rounded-lg border-blue-500 bg-white from-purple-600 to-blue-500 px-5  py-2.5 text-center text-sm font-medium text-black hover:bg-linear-to-bl hover:text-white focus:outline-none focus:ring-4 focus:ring-blue-300'
            onClick={() => {
              logEventToPosthog('optimizerLiteBulkGenerateClicked');
              setOpenModal(true);
            }}
          >
            Bulk generate for all flow emails
          </Button>
        </Card>
      </div>
      <Modal
        dismissible
        show={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
      >
        <ModalHeader>
          This feature and more are available on Optimizer Pro. <br />
          Let’s chat!
        </ModalHeader>
        <ModalBody>
          <InlineWidget url='https://calendly.com/d/3kh-hk8-mr3/maverick-demo' />
        </ModalBody>
      </Modal>
    </>
  );
}
